module.exports = {
    'utils_notify.back': 'Indietro',
    'utils_notify.retry': 'Torna Indietro',
    'utils_notify.delete': 'Elimina',
    'utils_notify.discard': 'Cancella',
    'utils_notify.save': 'Salva',

    'utils_notify.confirm': 'Procedi',
    "utils_notify.edit": "Modifica",
    "utils_notify.success": "Ok!",
    "utils_notify.error": "Errore!",
    "utils_notify.warning": "Attenzione!",
    "utils_notify.info": "Info!",

    'utils_notify.confirm_action': "Sei sicuro di voler proseguire {0}?",
    'utils_notify.confirm_action.detail': 'Clicca su procedi per continuare',
    'utils_notify.confirm_action_title': 'Conferma azione',
    "utils_notify.confirm_delete": "Vuoi cancellare veramente '{0}' ?",
    "utils_notify.confirm_update": "Vuoi salvare le modifiche a '{0}' ?",
    "utils_notify.confirm_update.no_name": "Vuoi salvare le modifiche?",
    "utils_notify.confirm_update.detail": "Le modifiche non salvate andranno perse.",
    "utils_notify.confirm_delete.detail": "Attenzione! Non sarà possibile annullare quest'azione.",
    "utils_notify.insert_success": "'{0}' è stato aggiunto con successo.",
    "utils_notify.insert_head": '',
    "utils_notify.insert_error": "'{0}' non è stato aggiunto a causa di un errore.",
    "utils_notify.update_success": "{0} è stato aggiornato con successo.",
    "utils_notify.update_head": "Modificato!",
    "utils_notify.update_error": "'{0}' non è stato modificato a causa di un errore.",
    "utils_notify.delete_head": "Eliminato!",
    "utils_notify.delete_success": "'{0}' è stato eliminato con successo.",
    "utils_notify.delete_error": "'{0}' non è stato eliminato a causa di un errore. Altri elementi nel sistema potrebbero dipendere da esso.",
    "utils_notify.confirm_delete_title": 'Conferma eliminazione',
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/languages/it.js
// module id = 435
// module chunks = 0